import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import Grid from '@/global/components/ui/Grid'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useFormContext, useWatch } from 'react-hook-form'

/** Horário sugerido ao habilitar a entrada no dia seguinte. */
const ENTRADA_PADRAO = '23:00'

export const ControleSection = () => {
    const { setValue } = useFormContext()
    /**
     * Campo só de tela: não existe no funcionário, vem do `defaultValues` de
     * cada modal como `!!entradaDiaSeguinte` e o `whitelist` da API descarta.
     * É ele que diz se o horário é editável.
     */
    const possuiEntradaDiaSeguinte = useWatch({
        name: 'possuiEntradaDiaSeguinte',
    })

    return (
        <section id="controle">
            <HorizontalDivider className="mb-4">Controle</HorizontalDivider>
            <Grid container>
                <Grid item xs={12}>
                    <FormField
                        name="nomeSocial"
                        label="Nome social"
                        placeholder="Nome para o e-social"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormFieldCheckbox
                        name="possuiEntradaDiaSeguinte"
                        label="Entrada no dia seguinte"
                        onChange={marcado =>
                            setValue(
                                'entradaDiaSeguinte',
                                marcado ? ENTRADA_PADRAO : null,
                            )
                        }
                        endAdornment={
                            <IconeAjuda>
                                Se o funcionário faz uma jornada que começa em
                                dia, tem uma pausa e volta a trabalhar no dia
                                seguinte, você pode marcar essa opção e definir
                                o horário de entrada. Assim, o horário de
                                entrada (geralmente após a meia noite) será
                                considerado como entrada na jornada correta.
                            </IconeAjuda>
                        }
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        name="entradaDiaSeguinte"
                        label="Horário de entrada"
                        disabled={possuiEntradaDiaSeguinte !== true}
                        options={{
                            timePattern: ['h', 'm'],
                            time: true,
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormFieldCheckbox
                        label="Recebe vale alimentação"
                        name="recebeValeAlimentacao"
                        endAdornment={
                            <IconeAjuda>
                                Desmarque essa opção caso você não queira que o
                                funcionário seja incluído no relatório de vale
                                alimentação nem que o valor do vale alimentação
                                seja considerado na integração da folha de
                                pagamento.
                            </IconeAjuda>
                        }
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        label="Bônus de vale"
                        name="bonusValeAlimentacao"
                        type="number"
                        endAdornment={
                            <div className="inline-flex items-center">
                                <span>%</span>
                                <IconeAjuda>
                                    Esse é o bônus que vai ser aplicado sobre o
                                    valor do vale alimentação.
                                </IconeAjuda>
                            </div>
                        }
                    />
                </Grid>
            </Grid>
        </section>
    )
}
